import { useChatDraftStore } from "@/stores/useChatDraftStore";
import { useChatStore } from "@/stores/useChatStore";
import { useToastStore } from "@/stores/useToastStore";

/** 環境の中のパスをクリップボードへ写す (右クリックの「パスをコピー」)。 */
export async function copyPathToClipboard(path: string): Promise<void> {
	await navigator.clipboard.writeText(path);
	useToastStore.getState().show({ type: "success", message: "パスをコピーしました。" });
}

/** 開いているチャットの入力欄へ環境の中のパスを足す (右クリックの「メッセージにパスを追加」)。 */
export function insertPathIntoMessage(path: string): void {
	const chatId = useChatStore.getState().chatId;
	if (chatId === null) return;
	useChatDraftStore.getState().queueDraftInsert(chatId, path);
}
